module.exports = __webpack_public_path__ + "static/media/truck-travel@3x.3f99e602.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/truck-travel@3x.png
// module id = 1898
// module chunks = 0